const projectsInfo = [
  {
    id: 1,
    name: "Anonymous server",
    description:
      "Simple página responsive con un menú desplegable. Hecho con HTML heredado sin posibilidad de modificarlo, y añadiendo estilos con CSS y funcionalidad con JavaScript, sin usar frameworks CSS o preprocesadores.",
    dev: ["HTML5", "CSS3", "JavaScript", "ES6", "Diseño Responsive"],
    img: require("../images/projects/AnonymousServer_cover.png"),
    demo: "http://beta.adalab.es/f-online-anonymous-server-mirenguerra/",
    code:
      "https://github.com/mirenguerra/f-online-anonymous-server-mirenguerra",
  },
  {
    id: 2,
    name: "Rock & Code",
    description:
      "Página web responsive en la que nos presentamos como grupo Realizado principalmente con CSS3 y SASS.",
    dev: ["HTML5", "CSS3", "SASS", "ES6", "Diseño Responsive"],
    img: require("../images/projects/RockandCode_cover.png"),
    demo: "http://beta.adalab.es/f-m1-rock-code/",
    code: "https://github.com/mirenguerra/f-m1-rock-code",
  },
  {
    id: 3,
    name: "Adivina el número",
    description:
      "Juego presentado por una ranita que consiste en adivinar un número aleatorio. La ranita croa cuando aciertas el número. Realizado principalmente con JavaScript.",
    dev: ["HTML5", "CSS3", "SASS", "JavaScript", "gulp", "ES6"],
    img: require("../images/projects/AdivinaElNumero_cover.png"),
    demo: "http://beta.adalab.es/f-m2-evaluacion-intermedia-mirenguerra/",
    code:
      "https://github.com/mirenguerra/f-m2-evaluacion-intermedia-mirenguerra",
  },
  {
    id: 4,
    name: "Life calendar",
    description:
      "Simple aplicación con un calendario en el que se puede anotar cómo ha ido el día con un smiley. Realizado con React.",
    dev: ["HTML5", "CSS3", "SASS", "React", "ES6"],
    img: require("../images/projects/LifeCalendar_cover.png"),
    demo: "http://beta.adalab.es/f-online-life-calendar-mirenguerra/",
    code: "https://github.com/mirenguerra/f-online-life-calendar-mirenguerra",
  },
  {
    id: 5,
    name: "Awesome Profile Cards",
    description:
      "Página web responsive que permite al usuario crear una tarjeta de visita virtual, personalizando su diseño y compartirla gracias de un link o publicarla directamente en Twitter.",
    dev: ["HTML5", "CSS3", "SASS", "JavaScript", "Diseño Responsive", "ES6"],
    img: require("../images/projects/AwesomeProfileCards_cover.png"),
    demo: "http://beta.adalab.es/fairfax-m2-frontNerds/",
    code: "https://github.com/mirenguerra/fairfax-m2-frontNerds",
  },
  {
    id: 6,
    name: "Awesome Profile Cards - Migración a React",
    description:
      "Migración del proyecto Awesome Profile Cards a React y refactorización de código.",
    dev: [
      "HTML5",
      "CSS3",
      "SASS",
      "JavaScript",
      "Diseño Responsive",
      "React",
      "ES6",
      "API REST",
    ],
    img: require("../images/projects/AwesomeProfileCardsReact_cover.png"),
    demo: "http://beta.adalab.es/fairfax-m3-groot.join/",
    code: "https://github.com/mirenguerra/fairfax-m3-groot.join",
  },
  {
    id: 7,
    name: "Bmind Holidays",
    description:
      "SPA para solicitar vacaciones y guardarlas, realizada en apenas 30 horas para la empresa BMind. Los datos se obtienen de una API y se muestran los días de vacaciones de todos los empleados en un calendario anual, pudiendo además filtrar por año.",
    dev: ["HTML5", "CSS3", "SASS", "JavaScript", "React", "ES6", "API REST"],
    img: require("../images/projects/BmindHolidays_cover.png"),
    demo: "http://beta.adalab.es/f-m4-bmind-calendar/",
    code: "https://github.com/mirenguerra/f-m4-bmind-calendar",
  },
  {
    id: 8,
    name: "Harry Potter Characters",
    description:
      "SPA que recibe datos sobre personajes de las películas de Harry Potter desde una API pública y que permite aplicar distintos filtros. Cada personaje tiene una página de detalle que muestra más información.",
    dev: [
      "HTML5",
      "CSS3",
      "SASS",
      "JavaScript",
      "Diseño Responsive",
      "React",
      "ES6",
      "API REST",
    ],
    img: require("../images/projects/HarryPotterCharacters_cover.png"),
    demo: "http://beta.adalab.es/f-m3-evaluacion-final-mirenguerra/#/",
    code: "https://github.com/mirenguerra/f-m3-evaluacion-final-mirenguerra",
  },
  {
    id: 9,
    name: "Pokemon Pokedex",
    description:  "SPA que recibe datos sobre personajes de Pokemon desde una API pública y que permite filtrar personajes por nombre. Cada personaje tiene una página de detalle que muestra más información. Se ha creado realizando peticiones encadenadas a la API",
    dev: [
      "HTML5",
      "CSS3",
      "SASS",
      "JavaScript",
      "Diseño Responsive",
      "React",
      "ES6",
      "API REST",
    ],
    img: require("../images/projects/PokemonPokedex_cover.png"),
    demo: "http://beta.adalab.es/f-online-pokemon-mirenguerra/",
    code: "mirenguerra/f-online-pokemon-mirenguerra",
  },
  // {
  //   id: 8,
  //   name: "",
  //   description: "",
  //   dev: [],
  //   img: require(".............."),
  //   demo: "",
  //   code: ""
  // }
];

export default projectsInfo;
